import { css } from 'styled-components';

import { styledTypography } from '@pkg/primitives';

export const PLACEHOLDER = 'Write a short biography…';
export const LENGTH_ERROR = 'Bio must be less than 160 characters.';

export const tokens = {
    padding: {
        // Unable to use `textBoxTrim` on a `<textarea />`
        // so we have to specify different padding values.
        top: 6,
        rest: 10,
    },
    minWidthCh: PLACEHOLDER.length,
    fontSize: 16,
    radius: 10,
};

export const baseWrapperStyles = css`
    display: inline-grid;
    justify-content: start;
    justify-items: start;
`;

export const baseTextStyles = css`
    ${styledTypography.allianceBase};
    padding-top: ${tokens.padding.top}px;
    padding-bottom: ${tokens.padding.rest}px;
    padding-left: ${tokens.padding.rest}px;
    padding-right: ${tokens.padding.rest}px;
    min-width: 100%;
    font-size: ${tokens.fontSize}px;
    font-weight: 500;
    line-height: 1.2;
    letter-spacing: -0.02em;

    @media (min-width: 768px) {
        min-width: ${tokens.minWidthCh}ch;
    }
`;

export const textElementStyles = css`
    ${baseTextStyles};
    ${styledTypography.breakTextarea};
`;
